import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles({
  errorSwapRight: {
    border: '1px solid red',
  },
});
